import Card from '@mui/material/Card';
import { CardActionArea } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Link, useLocation } from 'react-router-dom';
import { Teacher } from '../../../types/Teacher';
import ProfilePicture from '../../ProfileImage';
import { trackClickEvent } from '../../../utils/functions/trackEvent';
import Rate from '../../Rate';
import './ResultCard.css';

const ResultCard = ({ result }: { result: Teacher }) => {
  const location = useLocation();

  const handleResultClick = () => {
    trackClickEvent('result_card', result.external_id);
  };

  return (
    <Link
      to={{
        pathname: `/teachers/${result.external_id}/profile`,
        search: location.search
      }}
      className="resultCard"
      onClick={handleResultClick}>
      <Card>
        <CardActionArea>
          <CardContent sx={{ padding: '10px 20px 20px 20px' }}>
            <div className="resultCardHeader">
              <ProfilePicture image_url={result.image_url} />
              <div className="resultCardTitle">
                <Typography
                  variant="h5"
                  component="div"
                  sx={{
                    fontSize: {
                      sm: '1.5rem',
                      xs: '1rem'
                    }
                  }}
                  className="resultCardName">
                  {result.first_name} {result.last_name}
                  {result.rate && result.rate.average > 0 && <Rate rate={result.rate} />}
                </Typography>
              </div>
              <div className="resultCardPrice">
                <h4>${result.price_per_hour}</h4>
                <span className="byHour">por hora</span>
              </div>
            </div>
            <Typography variant="body2" color="text.secondary" className="profileDescription">
              {result.profile_description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Link>
  );
};

export default ResultCard;
